import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import '../../../styles/errorboundary.css';
import { useNavigate } from 'react-router-dom';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import picError from '../../../../src/assets/images/404.gif';
import { t } from "i18next";
import axios from "axios";
import { useDispatch } from "react-redux";
import API_Routes from '../../../constants/api-routes';
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
 
 
 
  static getDerivedStateFromError(error) {
    return { hasError: true };
  }
 
  componentDidCatch(error, errorInfo) {
    // Log the error to an error reporting service (if applicable)
    try{
      console.error(error, errorInfo);
    }catch(e){
      console.log(e);
    }
  }
 
  reloadPage = () => {
    window.location.reload();
  };
 
  // handleLogout = (e) => {
  //   console.log('logout');
    
  // };

  
  
  handleLogout = (e) => {
    console.log("Logout");
    const formData = this.props.csrfFormTagName + "=" + this.props.csrfToken;
    async function logout(params) {
      const response = await axios
        .post(API_Routes.logout, formData, { withCredentials: true })
        .then((res) => {
          console.log(res.status);
          if (res.status === 200) {
            window.location.reload();
          }
        });
    }
    logout();
  };
  render() {
    if (this.state.hasError) {
        return (
          <div className="bg-white vh-100 text-center">
            <Col>
            <img src={picError} className='mx-auto'></img>
           
            <h2 className='text-danger'>{t("general.label.error")}</h2>
            <h5>{t("general.label.inconvenience.error")}</h5>
            <div className="button-container" onClick={(e) => this.reloadPage}>
              <Button variant="primary" onClick={(e) => this.reloadPage()} className='m-2'>
              <i class="ti ti-home"></i> {t("general.label.go.home")}
              </Button>
              <Button variant="secondary" onClick={(e) => this.handleLogout(e)} className='m-2'>
              <i class="ti ti-logout"></i> {t("general.label.log.out")}
              </Button>
            </div>
            </Col>
          </div>
        );
        }
    return this.props.children;
  }
}
 
export default ErrorBoundary;
 












